export enum AegStatusEnum {
    REQUEST_OPENING = 'REQUEST_OPENING',
    PENDING_ANALYSIS = 'PENDING_ANALYSIS',
    PRE_APPROVAL = 'PRE_APPROVAL',
    WARRANTY_ANALYSIS = 'WARRANTY_ANALYSIS',
    CORRECT = 'CORRECT',
    REJECTED = 'REJECTED',
    CREDITED = 'CREDITED',
}

export enum AegRequestTypeEnum {
    AEG = 'AEG',
    WARRANTY_TREATMENT = 'WARRANTY_TREATMENT',
}

export enum AegApprovalTypeEnum {
    REGIONAL = 'REGIONAL',
    VOLKSTOTAL = 'VOLKSTOTAL',
}

export enum AegVehicleTypeEnum {
    TRUCK = 'TRUCK',
    EXTRA_HEAVY_TRUCK = 'EXTRA_HEAVY_TRUCK',
    BUS = 'BUS',
}

export enum AegAssignToEnum {
    NOBODY = 'NOBODY',
    AFTER_SALES_CONSULTANT = 'AFTER_SALES_CONSULTANT',
    AT_ENGINEER = 'AT_ENGINEER',
    WARRANTY_ANALYST = 'WARRANTY_ANALYST',
    DEALERSHIP = 'DEALERSHIP',
}

export enum AegImplementOrBodyBuilderEnum {
    DRY_CARGO_VAN = 'DRY_CARGO_VAN',
    REFRIGERATED_VAN = 'REFRIGERATED_VAN',
    TARPAULIN_VAN = 'TARPAULIN_VAN',
    DRY_CARGO = 'DRY_CARGO',
    GRAIN_BODY = 'GRAIN_BODY',
    TIPPER = 'TIPPER',
    CONTAINER_CARRIER = 'CONTAINER_CARRIER',
    CARBON_TANK = 'CARBON_TANK',
    STAINLESS_TANK = 'STAINLESS_TANK',
    ALUMINUM_TANK = 'ALUMINUM_TANK',
    SUGARCANE = 'SUGARCANE',
    FORESTRY = 'FORESTRY',
    FLATBED_ALL = 'FLATBED_ALL',
    PLATFORM = 'PLATFORM',
    CAR_CARRIER = 'CAR_CARRIER',
    DOLLY = 'DOLLY',
    SPECIAL_IMPLEMENT = 'SPECIAL_IMPLEMENT',
    SIDER = 'SIDER',
    EXTENDABLE = 'EXTENDABLE',
    ROAD_TRAIN = 'ROAD_TRAIN',
    BITREM = 'BITREM',
    JULIETA = 'JULIETA',
    SELF_RESCUE_PLATFORM = 'SELF_RESCUE_PLATFORM',
    COIL_CARRIER = 'COIL_CARRIER',
    GAS_TRANSPORT = 'GAS_TRANSPORT',
    CEMENT_TRANSPORT = 'CEMENT_TRANSPORT',
    GLASS_TRANSPORT = 'GLASS_TRANSPORT',
    MILK_COLLECTION = 'MILK_COLLECTION',
    ROLL_ON_ROLL_OFF = 'ROLL_ON_ROLL_OFF',
    POLIGUINDASTE = 'POLIGUINDASTE',
    WASTE_COMPACTOR = 'WASTE_COMPACTOR',
    CONCRETE_MIXER = 'CONCRETE_MIXER',
    BEVERAGE_BODY = 'BEVERAGE_BODY',
    TOW_TRUCK = 'TOW_TRUCK',
    CHASSIS_TANK = 'CHASSIS_TANK',
    MOBILE_UNIT = 'MOBILE_UNIT',
    MOBILE_WORKSHOP = 'MOBILE_WORKSHOP',
    AMBULANCE = 'AMBULANCE',
    TRAILER = 'TRAILER',
    MACHINE_CARRIER = 'MACHINE_CARRIER',
    OTHERS = 'OTHERS',
}

export enum AegBodyBuilderNameEnum {
    MARCOPOLO = 'MARCOPOLO',
    CAIO = 'CAIO',
    BUSSCAR = 'BUSSCAR',
    COMIL = 'COMIL',
    MASCARELLO = 'MASCARELLO',
    NEOBUS = 'NEOBUS',
    IRIZAR_BRASIL = 'IRIZAR_BRASIL',
    VOLARE = 'VOLARE',
    INBRASP = 'INBRASP',
    MVI_BUS = 'MVI_BUS',
    SITCAR = 'SITCAR',
    TECNOBUS = 'TECNOBUS',
    HELIO_CARROCERIAS = 'HELIO_CARROCERIAS',
    BRABUS = 'BRABUS',
    CSM_CARROCERIAS = 'CSM_CARROCERIAS',
    TCA_CARROCERIAS = 'TCA_CARROCERIAS',
    MAXIBUS = 'MAXIBUS',
    GRANVIA = 'GRANVIA',
    RODOVIARIO_MEYER = 'RODOVIARIO_MEYER',
    MCAR = 'MCAR',
    OTHERS = 'OTHERS',
}

export enum AegServiceTypeEnum {
    TYPE_0 = 'TYPE_0',
    TYPE_1 = 'TYPE_1',
    TYPE_2 = 'TYPE_2',
    TYPE_3 = 'TYPE_3',
    TYPE_4 = 'TYPE_4',
    TYPE_5 = 'TYPE_5',
    TYPE_6 = 'TYPE_6',
    TYPE_7 = 'TYPE_7',
    TYPE_8 = 'TYPE_8',
    TYPE_A = 'TYPE_A',
    TYPE_B = 'TYPE_B',
    TYPE_C = 'TYPE_C',
    TYPE_M = 'TYPE_M',
    REVIEW_COUPON_WITH_VALUE = 'REVIEW_COUPON_WITH_VALUE',
    REVIEW_COUPON_WITHOUT_VALUE = 'REVIEW_COUPON_WITHOUT_VALUE',
}

export enum AegRepairScopeEnum {
    TOTAL = 'TOTAL',
    PARTIAL = 'PARTIAL',
}

export enum AegAttendanceConditionEnum {
    APPROVED_NOT_CONDITIONED = 'APPROVED_NOT_CONDITIONED',
    APPROVED_REMOTE_CONDITIONED = 'APPROVED_REMOTE_CONDITIONED',
    COMMERCIAL_COURTESY = 'COMMERCIAL_COURTESY',
    TECHNICAL_COURTESY = 'TECHNICAL_COURTESY',
    AGREEMENT_TECHNICAL_ASSISTANCE = 'AGREEMENT_TECHNICAL_ASSISTANCE',
    AGREEMENT_MAINTENANCE_CONTRACT = 'AGREEMENT_MAINTENANCE_CONTRACT',
}


export type AegOption = {
    id: string;
    labelId?: string;
    label?: string;
};

export type AegRequestForm = {
    requestType: AegRequestTypeEnum;
    approvalType: AegApprovalTypeEnum;
    responsible: string;
    dn: string;
    regional: string;
    responsibleDn: string;
    phone: string;
    occurrence: string;
    chassis: string;
    licensePlate: string;
    vehicleType: AegVehicleTypeEnum | '';
    customer: string;
    model: string;
    implement: AegImplementOrBodyBuilderEnum | '';
    implementOther: string;
    bodyBuilder: AegBodyBuilderNameEnum | '';
    bodyBuilderOther: string;
    cargo: string;
    odometer: string;
    hourMeter: string;
    repairDate: string;
    serviceOrder: string;
    warrantyRequest: string;
    serviceType: AegServiceTypeEnum | '';
    repairTotal: number;
    laborTotal: string;
    serviceCondition: AegAttendanceConditionEnum | '';
    hasThirdParty: boolean;
    thirdPartyServices: string;
    thirdPartyInvoiceValue: number;
    thirdPartyInvoiceNumber: string;
    repairScope: AegRepairScopeEnum;
    repairPercentage: string;
    controlCode: string;
    chameVolks: string;
    breakdown: boolean;
    fleetComposition: string;
    lastPurchase: string;
    companies: string;
    customerComplaint: string;
    dnDiagnosis: string;
    dnJustification: string;
    moveTo: AegStatusEnum;
    assignTo: string;
    attachments: File[];
};

export type AegOccurrenceRequest = {
    aegNumber?: string;
    status?: AegStatusEnum;
    requestType?: AegRequestTypeEnum;
    approvalType?: AegApprovalTypeEnum;
    responsible?: string;
    dn?: string;
    regional?: string;
    dnResponsible?: string;
    phone?: string;
    chassis?: string;
    licensePlate?: string;
    vehicleType?: AegVehicleTypeEnum;
    customer?: string;
    implementOrBodyBuilder?: AegImplementOrBodyBuilderEnum;
    implementOrBodyBuilderOther?: string;
    bodyBuilderName?: AegBodyBuilderNameEnum;
    bodyBuilderNameOther?: string;
    cargoTransport?: string;
    odometer?: number;
    hourMeter?: number;
    repairDate?: string;
    osNumber?: string;
    sgNumber?: string;
    serviceType?: AegServiceTypeEnum;
    repairTotal?: number;
    laborTotalUt?: number;
    hasThirdPartyService?: boolean;
    thirdPartyServices?: string;
    thirdPartyInvoiceAmount?: number;
    thirdPartyInvoiceNumbers?: string;
    repairScope?: AegRepairScopeEnum;
    partialPercentage?: number;
    controlCode?: string;
    chameVolksNumber?: string;
    breakdown?: string;
    customerComplaint?: string;
    dnDiagnosis?: string;
    dnJustification?: string;
    attendanceCondition?: AegAttendanceConditionEnum;
    fleetComposition?: string;
    lastVwcoManPurchase?: string;
    companies?: string;
    moveTo?: AegStatusEnum;
    assignTo?: string;
};

export type AegOccurrenceResponse = AegOccurrenceRequest & {
    id: number;
    createdBy?: string;
    availableToEdit?: boolean;
    createdAt?: string;
    updatedAt?: string;
};

export type AegRequestField = keyof AegRequestForm;

export type AegRequestErrors = Partial<Record<AegRequestField, boolean>>;

export type AegFormSectionProps = {
    values: AegRequestForm;
    errors: AegRequestErrors;
    requiredFields: AegRequestField[];
    onChange: <K extends AegRequestField>(field: K, value: AegRequestForm[K]) => void;
};

export type AegVehicle = {
    vehicleOwner?: string;
    model?: string;
    chassis?: string;
    licensePlate?: string;
    vehicleType?: string;
    color?: string;
    implementType?: string;
    productionDate?: string;
    billingDate?: string;
    saleDate?: string;
    tsDeliveryDate?: string;
    responsibleDealer?: string;
    warrantyEnd?: string;
    additionalWarrantyEnd?: string;
    contractNumber?: string;
    contractModality?: string;
    specialWarrantyEnd?: string;
    campaigns?: string;
    consultLegal?: string | boolean;
    vehicleBlocked?: boolean;
    hasWarranty?: boolean;
    hasVolksConfiaWarranty?: boolean;
    updatedAt?: string;
};

export type AegRequestFormBodyProps = AegFormSectionProps & {
    vehicle: AegVehicle | null;
    isLoadingVehicle: boolean;
};
